const IntegrationHistoryTabNames = {
  Created: { id: 'Created', name: 'New Users' },
  Updated: { id: 'Updated', name: 'Update Users' },
  Errors: { id: 'Errors', name: 'Total Errors' },
} as const;

export default IntegrationHistoryTabNames;
